import { Link } from "react-router-dom";
import Avatar from "@/components/base/Avatar";
import { categories } from "@/mocks/categories";
import { topics } from "@/mocks/topics";
import { formatViews } from "@/utils/format";

interface CategorySidebarProps {
  activeSlug: string;
}

export default function CategorySidebar({ activeSlug }: CategorySidebarProps) {
  const hot = [...topics].sort((a, b) => b.heat - a.heat).slice(0, 5);

  return (
    <aside className="flex flex-col gap-6">
      <div className="rounded-card border border-background-200 bg-background-100 p-5">
        <h2 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
          <span className="flex h-4 w-4 items-center justify-center text-accent-600">
            <i className="ri-layout-grid-line text-base" />
          </span>
          全部话题分类
        </h2>
        <ul className="mt-4 flex flex-col gap-1.5">
          {categories.map((cat) => {
            const isActive = cat.slug === activeSlug;
            return (
              <li key={cat.slug}>
                <Link
                  to={`/category/${cat.slug}`}
                  className={`flex items-center justify-between rounded-lg px-3 py-2.5 text-sm transition-colors ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-background-50"
                  }`}
                >
                  <span className="flex items-center gap-2">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className={`${cat.icon} text-base`} />
                    </span>
                    {cat.name}
                  </span>
                  <span className={`text-xs ${isActive ? "text-background-100" : "text-foreground-400"}`}>
                    {cat.count}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="rounded-card border border-background-200 bg-background-100 p-5">
        <h2 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
          <span className="flex h-4 w-4 items-center justify-center text-primary-600">
            <i className="ri-fire-line text-base" />
          </span>
          跨分类热瓜
        </h2>
        <ul className="mt-4 flex flex-col gap-4">
          {hot.map((topic) => (
            <li key={topic.id} className="flex gap-3">
              <Avatar name={topic.author} size="sm" tone="secondary" />
              <div className="min-w-0">
                <h3 className="line-clamp-2 text-sm leading-snug text-foreground-800">
                  <Link to={`/topic/${topic.id}`} className="transition-colors hover:text-primary-600">
                    {topic.title}
                  </Link>
                </h3>
                <p className="mt-1 text-[11px] text-foreground-500">
                  {topic.categoryName} · {formatViews(topic.views)} 阅读
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}